import { cn } from '@core/utils';

import { Rating } from '@/app/donation/_components/Rating';
import { ReviewDetailContent } from '@/app/donation/gifts/[productNumber]/_components/ReviewDetailContent';
import { Image } from '@/components/client';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { openResponsiveDialog } from '@/stores/DrawerStore';

interface WeeklyBestPhotoReviewListItemProps {
  reviewId: number;
  productThumbnailUrl: string;
  productName: string;
  rating: number;
  reviewContent: string;
}

export const WeeklyBestPhotoReviewListItem = ({
  reviewId,
  productThumbnailUrl,
  productName,
  rating,
  reviewContent,
}: WeeklyBestPhotoReviewListItemProps) => {
  const handleReviewClick = () => {
    openResponsiveDialog({
      component: ReviewDetailContent,
      modalHeader: '포토후기',
      className: {
        modal: 'max-w-[900px]',
      },
      props: {
        reviewId,
      },
      drawerNoPadding: true,
    });
  };

  return (
    <li
      className={cn(
        'flex w-fit items-center gap-16 rounded-large bg-Gray-white p-16 shadow-base',
        'mobile-tablet:p-12',
      )}
    >
      {/** 답례품 이미지 */}
      <button
        type="button"
        onClick={handleReviewClick}
        aria-label={`${productName} 후기 상세 보기`}
        className={cn(
          'relative size-104 overflow-hidden rounded-medium',
          'mobile-tablet:size-72',
        )}
      >
        <Image
          src={productThumbnailUrl}
          fill
          alt={`${productName} 이미지`}
          sizes={`${BREAKPOINTS.MOBILE_TABLET} 72px, 104px`}
          className="object-cover"
        />
      </button>

      <div
        className={cn(
          'flex w-237 flex-col',
          'mobile-tablet:h-72 mobile-tablet:w-198 mobile-tablet:justify-center',
        )}
      >
        {/** 별점 */}
        <Rating value={rating} size={12} />
        {/** 답례품명 */}
        <button
          type="button"
          aria-label={`${productName} 후기 상세 보기`}
          onClick={handleReviewClick}
          className="text-start"
        >
          <p
            className={cn(
              'line-clamp-1 py-2 font-600 text-Gray-900 typo-body4',
              'mobile-tablet:font-600 mobile-tablet:typo-caption1',
            )}
          >
            {productName}
          </p>
        </button>

        {/** 후기 */}
        <button
          type="button"
          onClick={handleReviewClick}
          className={cn(
            'pt-4 text-start font-400 text-Gray-600 typo-body4',
            'mobile-tablet:pt-0 mobile-tablet:font-400 mobile-tablet:typo-caption1',
          )}
          aria-label={`${productName} 후기 상세 보기`}
        >
          <span className="line-clamp-2 w-full text-left">{reviewContent}</span>
        </button>
      </div>
    </li>
  );
};
